import { z } from 'zod';
import { McpServerNameSchema } from '../ids.ts';

export const ConnectionSchema = z.object({
  object: z.literal('connection'),
  server: McpServerNameSchema,
  title: z.string(),
  connect_with: z.enum(['sign_in', 'api_key']),
  connected: z.boolean(),
});
export type Connection = z.infer<typeof ConnectionSchema>;

export const ConnectionListResponseSchema = z.object({ data: z.array(ConnectionSchema) });
export type ConnectionListResponse = z.infer<typeof ConnectionListResponseSchema>;

export const ConnectionKeyRequestSchema = z.object({ key: z.string().trim().min(1).max(4096) });
export type ConnectionKeyRequest = z.infer<typeof ConnectionKeyRequestSchema>;

export const ConnectionSignInSchema = z.object({
  object: z.literal('connection.sign_in'),
  ticket: z.string(),
});
export type ConnectionSignIn = z.infer<typeof ConnectionSignInSchema>;

export const ConnectionDeletedSchema = z.object({
  object: z.literal('connection.deleted'),
  server: McpServerNameSchema,
  deleted: z.literal(true),
});
export type ConnectionDeleted = z.infer<typeof ConnectionDeletedSchema>;

export const SIGN_IN_POPUP_MESSAGES = {
  ready: 'plato.sign_in.ready',
  ticket: 'plato.sign_in.ticket',
} as const;

export const SignInPopupTicketSchema = z.object({
  type: z.literal(SIGN_IN_POPUP_MESSAGES.ticket),
  ticket: z.string().min(1).max(4096),
});
export type SignInPopupTicket = z.infer<typeof SignInPopupTicketSchema>;
